module.exports = __webpack_public_path__ + "de6f403c6408c3fbf5a2c5122221f463.png";